import cx from "classnames"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation, Link } from "react-router"
import { SettingsModal } from "../../modules/SettingsModal"
import { NAVIGATION_KEYS, NAVIGATION_ICONS, NAVIGATION_ROUTES } from "./types"
import styles from "./index.module.css"

/* Menú propio de la dapp (NO es un componente de tutellus-components) con el
   tratamiento del navbar de tutellus.com: pegado al logo a la izquierda, item
   como "pill" (Clash 500 / 16px / hover con fondo), pero conservando los iconos
   de la dapp. "/" solo casa exacto; el resto por prefijo. */

const POAPS_ROUTE = NAVIGATION_ROUTES[NAVIGATION_KEYS.POAPS]
const WALLET_ROUTE = NAVIGATION_ROUTES[NAVIGATION_KEYS.WALLET]

export const NavBar = () => {
  const { t } = useTranslation("common", { keyPrefix: "navigation" })
  const { pathname } = useLocation()
  const [showSettingsModal, setShowSettingsModal] = useState(false)

  const isActive = (route: string) => (route === "/" ? pathname === "/" : pathname.startsWith(route))

  return (
    <nav className={styles.nav}>
      <ul className={styles.list}>
        <li>
          <Link to={POAPS_ROUTE} className={cx(styles.trigger, { [styles.active]: isActive(POAPS_ROUTE) })}>
            <span className={styles.icon}>{NAVIGATION_ICONS[NAVIGATION_KEYS.POAPS]}</span>
            {t(`${NAVIGATION_KEYS.POAPS}.title`)}
          </Link>
        </li>
        <li>
          <Link to={WALLET_ROUTE} className={cx(styles.trigger, { [styles.active]: isActive(WALLET_ROUTE) })}>
            <span className={styles.icon}>{NAVIGATION_ICONS[NAVIGATION_KEYS.WALLET]}</span>
            {t(`${NAVIGATION_KEYS.WALLET}.title`)}
          </Link>
        </li>
        <li>
          <button type="button" className={styles.trigger} onClick={() => setShowSettingsModal(true)}>
            <span className={styles.icon}>{NAVIGATION_ICONS[NAVIGATION_KEYS.SETTINGS]}</span>
            {t(`${NAVIGATION_KEYS.SETTINGS}.title`)}
          </button>
        </li>
      </ul>
      {showSettingsModal && <SettingsModal onClose={() => setShowSettingsModal(false)} />}
    </nav>
  )
}
